import React, { useRef, useEffect, useState } from "react";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { AuthStore } from "./store/authStore";
import CadDetail from "./components/cad/CadDetail";
import axios from "axios";
import { Checkbox, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { URL } from "./utils/api";

import "./MapView.css";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZGFuaXNoLWNvZGU0IiwiYSI6ImNscm80dnJsczA2N2wyaW1tbGw2MzQwangifQ.Wun2_61Gw7FHKyS_94g87w";

function MapView() {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(-98.5795); // eslint-disable-line no-unused-vars
  const [lat, setLat] = useState(39.8283); // eslint-disable-line no-unused-vars
  const [zoom, setZoom] = useState(3);
  const [selected, setSelected] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const [minSlider, setMinSlider] = useState(null);
  const [maxSlider, setMaxSlider] = useState(null);
  const [sliderValue, setSliderValue] = useState(0);
  const [allDays, setAllDays] = useState(null);
  const [forecastMode, setForecastMode] = useState(false);

  const [byIncident, setByIncident] = useState({});
  const [cadCallTypes, setCadCallTypes] = useState({});
  // filters
  const [stressChecked, setStressChecked] = useState({
    red: true,
    green: true,
    yellow: true,
    unknown: false,
  });
  const [heatmapEnabled, setHeatmapEnabled] = useState(true);
  const [allCallTypesSelected, setAllCallTypesSelected] = useState(true);

  const stressThresholdMap = {};

  const stressCheckChange = (type, val) => {
    const stressCheckMap = { ...stressChecked };
    stressCheckMap[type] = val;
    setStressChecked(stressCheckMap);
    const filter = [];
    for (let key of Object.keys(stressCheckMap)) {
      if (stressCheckMap[key]) {
        if (key === "unknown") {
          filter.push("gray");
        } else {
          filter.push(key);
        }
      }
    }

    map.current.setFilter("earthquakes-point", [
      "in",
      ["get", "color"],
      ["literal", filter],
    ]);
  };

  const heatmapChanged = (val) => {
    setHeatmapEnabled(val);
    map.current.setLayoutProperty(
      "earthquakes-heat",
      "visibility",
      val ? "visible" : "none"
    );
    map.current.setLayoutProperty(
      "earthquakes-heat-yellow",
      "visibility",
      val ? "visible" : "none"
    );
  };

  const filterCallTypeInMap = (callTypes) => {
    const filter = [];
    for (let key of Object.keys(callTypes)) {
      if (callTypes[key]) {
        filter.push(key);
      }
    }

    console.log(filter);

    map.current.setFilter("earthquakes-point", [
      "in",
      ["get", "Type"],
      ["literal", filter],
    ]);
  };

  const allCallTypeClicked = (val) => {
    setAllCallTypesSelected(val);
    const callTypes = { ...cadCallTypes };

    Object.keys(cadCallTypes).forEach((x) => (callTypes[x] = val));
    setCadCallTypes(callTypes);
    filterCallTypeInMap(callTypes);
  };

  const callTypeClicked = (key, val) => {
    const cadCallTypesMap = { ...cadCallTypes };
    cadCallTypesMap[key] = val;
    setCadCallTypes(cadCallTypesMap);
    filterCallTypeInMap(cadCallTypesMap);
  };

  const headers = () => {
    return {
      Authorization: `Bearer ${AuthStore.session.getIdToken().getJwtToken()}`,
    };
  };

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/navigation-night-v1",
      center: [lng, lat],
      zoom: zoom,
    });

    map.current.on("move", () => {
      setZoom(map.current.getZoom());
    });

    const days = new Set();
    map.current.on("load", async () => {
      // const stReqUrl = "/stress-threshold.json";
      // const geoReqUrl = "/geo.json";
      // let stressThreshold = (await axios.get(stReqUrl)).data;
      // let data = (await axios.get(geoReqUrl)).data;

      let stressThreshold = (
        await axios.get(
          `${URL}/sample-file?key=stress-map/stress-threshold.json`,
          { headers: headers() }
        )
      ).data;
      let data = (
        await axios.get(`${URL}/sample-file?key=stress-map/geo.json`, {
          headers: headers(),
        })
      ).data;
      let dataAll = axios.get(
        `${URL}/sample-file?key=stress-map/geo-all.json`,
        { headers: headers() }
      );

      stressThreshold = JSON.parse(stressThreshold);
      data = JSON.parse(data);

      for (let threshold of stressThreshold) {
        stressThresholdMap[threshold.userid] = threshold;
      }

      data.features.forEach((x) => {
        x.properties.color = "gray";
        x.properties.colorStress = "gray";
        x.properties.strokeWidth = 1;
        x.properties.mag = 0;
        x.properties.colorOpacity = 0.3;

        let time = new Date(x.properties.start_timestamp);
        const offset = time.getTimezoneOffset();
        time = new Date(time.getTime() - offset * 60 * 1000);
        const day = time.toISOString().split("T")[0];

        x.properties.day = day;
        let reds = [];
        let yellow = [];
        let green = [];
        for (let user of Object.keys(x.properties.stress_metrics)) {
          days.add(day);
          const threshold = x.properties.stress_metrics[user].mean_stress_index;
          x.properties.strokeWidth = 2;
          const thresholdLevels = stressThresholdMap[user];

          if (threshold >= thresholdLevels.stress_index_p90) {
            reds.push(1);
          } else if (threshold >= thresholdLevels.stress_index_p75) {
            yellow.push(1);
          } else {
            green.push(1);
          }
          x.properties.colorOpacity = 0.8;
        }
        if (reds.length + yellow.length + green.length === 0) {
          //do nothing
        } else if (
          reds.length >= yellow.length &&
          reds.length >= green.length
        ) {
          x.properties.color = "red";
          x.properties.mag = 10;
        } else if (
          yellow.length >= reds.length &&
          yellow.length >= green.length
        ) {
          x.properties.color = "yellow";
          x.properties.mag = 5;
        } else if (
          green.length >= reds.length &&
          green.length >= yellow.length
        ) {
          x.properties.color = "green";
          x.properties.mag = 5;
        }

        reds = [];
        yellow = [];
        green = [];
        for (let user of Object.keys(x.properties.forecast_metrics)) {
          const threshold =
            x.properties.forecast_metrics[user].mean_stress_index_10;
          const thresholdLevels = stressThresholdMap[user];
          if (threshold >= thresholdLevels.stress_index_p90) {
            reds.push(1);
          } else if (threshold >= thresholdLevels.stress_index_p75) {
            yellow.push(1);
          } else {
            green.push(1);
          }
        }

        if (reds.length + yellow.length + green.length === 0) {
          //do nothing
        } else if (
          reds.length >= yellow.length &&
          reds.length >= green.length
        ) {
          x.properties.colorStress = "red";
        } else if (
          yellow.length >= reds.length &&
          yellow.length >= green.length
        ) {
          x.properties.colorStress = "yellow";
        } else if (
          green.length >= reds.length &&
          green.length >= yellow.length
        ) {
          x.properties.colorStress = "green";
        }
      });

      const allDays = [...days];
      allDays.sort();
      setAllDays(allDays);
      setMinSlider(0);
      setMaxSlider(allDays.length);
      setSliderValue(0);
      setSelectedDate(null);

      const dataHeatmapRed = {
        type: "FeatureCollection",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
        },
        features: data.features.filter((x) => x.properties.color === "red"),
      };

      const dataHeatmapYellow = {
        type: "FeatureCollection",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
        },
        features: data.features.filter((x) => x.properties.color === "yellow"),
      };

      // data = dataHeatmap;

      // Add a geojson point source.
      // Heatmap layers also work with a vector tile source.
      map.current.addSource("earthquakesHeatRed", {
        type: "geojson",
        data: dataHeatmapRed,
      });

      map.current.addSource("earthquakesHeatYellow", {
        type: "geojson",
        data: dataHeatmapYellow,
      });

      map.current.addSource("earthquakes", {
        type: "geojson",
        data: data,
      });

      map.current.addLayer(
        {
          id: "earthquakes-point",
          type: "circle",
          source: "earthquakes",
          minzoom: 7,
          paint: {
            // Size circle radius by earthquake magnitude and zoom level
            "circle-radius": ["interpolate", ["linear"], ["zoom"], 7, 4, 16, 5],
            // Color circle by earthquake magnitude
            "circle-color": ["get", "color"],
            "circle-stroke-color": ["get", "colorStress"],
            "circle-stroke-opacity": 1,
            "circle-stroke-width": ["get", "strokeWidth"],

            // Transition from heatmap to circle layer by zoom level
            "circle-opacity": ["get", "colorOpacity"],
          },
        },
        "waterway-label"
      );

      map.current.addLayer(
        {
          id: "earthquakes-heat-yellow",
          type: "heatmap",
          source: "earthquakesHeatYellow",
          maxzoom: 13,
          paint: {
            // Increase the heatmap weight based on frequency and property magnitude
            "heatmap-weight": [
              "interpolate",
              ["linear"],
              ["get", "mag"],
              0,
              0,
              8,
              6,
            ],
            // Increase the heatmap color weight weight by zoom level
            // heatmap-intensity is a multiplier on top of heatmap-weight
            "heatmap-intensity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              1,
              9,
              12,
            ],
            // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
            // Begin color ramp at 0-stop with a 0-transparancy color
            // to create a blur-like effect.
            "heatmap-color": [
              "interpolate",
              ["linear"],
              ["heatmap-density"],
              0,
              "rgba(215,226,55,0)",
              0.25,
              "rgba(215,226,55,0.25)",
              0.5,
              "rgba(215,226,55,0.5)",
              0.75,
              "rgba(215,226,55,0.75)",
              1,
              "rgba(215,226,55, 0.75)",
            ],
            // Adjust the heatmap radius by zoom level
            "heatmap-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              2,
              12,
              12,
            ],
            // Transition from heatmap to circle layer by zoom level
            "heatmap-opacity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              9,
              1,
              12,
              0,
            ],
          },
        },
        "waterway-label"
      );

      map.current.addLayer(
        {
          id: "earthquakes-heat",
          type: "heatmap",
          source: "earthquakesHeatRed",
          maxzoom: 13,
          paint: {
            // Increase the heatmap weight based on frequency and property magnitude
            "heatmap-weight": [
              "interpolate",
              ["linear"],
              ["get", "mag"],
              0,
              0,
              8,
              6,
            ],
            // Increase the heatmap color weight weight by zoom level
            // heatmap-intensity is a multiplier on top of heatmap-weight
            "heatmap-intensity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              1,
              9,
              12,
            ],
            // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
            // Begin color ramp at 0-stop with a 0-transparancy color
            // to create a blur-like effect.
            "heatmap-color": [
              "interpolate",
              ["linear"],
              ["heatmap-density"],
              0,
              "rgba(33,102,172,0)",
              0.2,
              "rgba(103,169,207, 0.75)",
              0.4,
              "rgba(209,229,240, 0.75)",
              0.6,
              "rgba(253,219,199, 0.75)",
              0.8,
              "rgba(239,138,98, 0.75)",
              1,
              "rgba(178,24,43, 0.75)",
            ],
            // Adjust the heatmap radius by zoom level
            "heatmap-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              2,
              12,
              12,
            ],
            // Transition from heatmap to circle layer by zoom level
            "heatmap-opacity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              9,
              1,
              12,
              0,
            ],
          },
        },
        "waterway-label"
      );

      map.current.on("click", (e) => {
        const bbox = [
          [e.point.x - 2, e.point.y - 2],
          [e.point.x + 2, e.point.y + 2],
        ];

        const selectedFeatures = map.current.queryRenderedFeatures(bbox, {
          layers: ["earthquakes-point"],
        });

        const mapped = selectedFeatures.map((x) => {
          return { properties: { ...x.properties } };
        });

        const uniqueMap = {};
        mapped.forEach((x) => {
          x.keys = Object.keys(x.properties);
          x.keys.sort();
          uniqueMap[x["Incident #"]] = x;
        });

        const values = [...Object.values(uniqueMap)];
        setSelected(values);
      });

      const geoAll = (await dataAll).data;

      const callTypeSet = new Set();
      const byIncident = {};

      JSON.parse(geoAll).features.forEach((x) => {
        const y = x.properties;
        byIncident[y["Incident #"]] = y;

        callTypeSet.add(y["Type"]);
        Object.keys(y.stress).forEach((user) => {
          const thresholdLevels = stressThresholdMap[user];
          y.stress[user].forEach((record) => {
            const threshold = record.stress_index;
            if (threshold >= thresholdLevels.stress_index_p90) {
              record.color = "red";
            } else if (threshold >= thresholdLevels.stress_index_p75) {
              record.color = "yellow";
            } else {
              record.color = "green";
            }
          });
        });

        Object.keys(y.forecast).forEach((user) => {
          const thresholdLevels = stressThresholdMap[user];
          y.forecast[user].forEach((record) => {
            const threshold = record.stress_index;
            if (threshold >= thresholdLevels.stress_index_p90) {
              record.color = "red";
            } else if (threshold >= thresholdLevels.stress_index_p75) {
              record.color = "yellow";
            } else {
              record.color = "green";
            }
          });
        });
      });

      setByIncident(byIncident);
      const callTypes = [...callTypeSet];
      callTypes.sort();
      const cadCallTypes = {};
      for (let callType of callTypes) {
        cadCallTypes[callType] = true;
      }
      setCadCallTypes(cadCallTypes);

      // setSelected([
      //   data.features.find(
      //     (x) => x.properties["Incident #"] === "2023-00050894"
      //   ),
      // ]);
    });
  });

  const sliderValueChanged = (newValue) => {
    newValue = parseInt(newValue);
    if (newValue === 0) {
      allTimeClicked();
    } else {
      setSliderValue(newValue);
      const index = newValue - 1;
      setSelectedDate(allDays[index]);
      map.current.setFilter("earthquakes-point", [
        "==",
        ["get", "day"],
        allDays[index],
      ]);
      map.current.setFilter("earthquakes-heat", [
        "==",
        ["get", "day"],
        allDays[index],
      ]);
      map.current.setFilter("earthquakes-heat-yellow", [
        "==",
        ["get", "day"],
        allDays[index],
      ]);
    }
  };

  const allTimeClicked = () => {
    map.current.setFilter("earthquakes-point", ["!=", ["get", "day"], null]);
    map.current.setFilter("earthquakes-heat", ["!=", ["get", "day"], null]);
    map.current.setFilter("earthquakes-heat-yellow", [
      "!=",
      ["get", "day"],
      null,
    ]);
    setSliderValue(0);
    setSelectedDate(null);
  };

  const forecastToggle = (forecastMode) => {
    setForecastMode(forecastMode);

    if (forecastMode) {
      map.current.setPaintProperty("earthquakes-point", "circle-color", [
        "get",
        "colorStress",
      ]);
    } else {
      map.current.setPaintProperty("earthquakes-point", "circle-color", [
        "get",
        "color",
      ]);
    }
  };

  return (
    <div className="App">
      <div className="sidebar">
        {/* <button className="button-2" onClick={allTimeClicked}>
          All time
        </button> */}
        <button
          className="button-2"
          onClick={() => forecastToggle(!forecastMode)}
        >
          {forecastMode ? "Actuals" : "Forecast"}
        </button>
        <Dropdown
          dropdownRender={(menu) => (
            <div
              style={{
                background: "rgba(255,255,255,0.9)",
                padding: "20px",
                margin: "5px",
                borderRadius: "5px",
              }}
            >
              <Checkbox
                checked={stressChecked["red"]}
                onChange={() => {
                  stressCheckChange("red", !stressChecked["red"]);
                }}
              >
                Red
              </Checkbox>
              <Checkbox
                checked={stressChecked["yellow"]}
                onChange={() => {
                  stressCheckChange("yellow", !stressChecked["yellow"]);
                }}
              >
                Yellow
              </Checkbox>
              <Checkbox
                checked={stressChecked["green"]}
                onChange={() => {
                  stressCheckChange("green", !stressChecked["green"]);
                }}
              >
                Green
              </Checkbox>
              <Checkbox
                checked={stressChecked["unknown"]}
                onChange={() => {
                  stressCheckChange("unknown", !stressChecked["unknown"]);
                }}
              >
                Unknown
              </Checkbox>

              <div style={{ marginTop: "20px" }}>
                <Checkbox
                  checked={heatmapEnabled}
                  onChange={() => {
                    heatmapChanged(!heatmapEnabled);
                  }}
                >
                  Heatmap
                </Checkbox>
              </div>
            </div>
          )}
        >
          <a onClick={(e) => e.preventDefault()}>
            <button className="button-2">
              Stress <DownOutlined />
            </button>
          </a>
        </Dropdown>

        <Dropdown
          dropdownRender={(menu) => (
            <div
              style={{
                background: "rgba(255,255,255,0.8)",
                padding: "20px",
                margin: "5px",
                borderRadius: "5px",
              }}
            >
              <Checkbox
                checked={allCallTypesSelected}
                onClick={() => allCallTypeClicked(!allCallTypesSelected)}
                style={{ width: "200px" }}
              >
                Select All
              </Checkbox>

              <div>
                {Object.keys(cadCallTypes).map((x) => {
                  return (
                    <Checkbox
                      onClick={() => callTypeClicked(x, !cadCallTypes[x])}
                      checked={cadCallTypes[x]}
                      style={{ width: "200px" }}
                    >
                      {x}
                    </Checkbox>
                  );
                })}
              </div>
            </div>
          )}
        >
          <a onClick={(e) => e.preventDefault()}>
            <button className="button-2">
              Call types <DownOutlined />
            </button>
          </a>
        </Dropdown>
      </div>

      <div className="topbar">
        <input
          type="range"
          min={minSlider}
          max={maxSlider}
          value={sliderValue}
          className="slider"
          onChange={(e) => {
            sliderValueChanged(e.target.value);
          }}
        />
        {selectedDate}
      </div>

      {selected && selected.length > 0 && (
        <div className="sidebar-right">
          {selected &&
            selected.map((x) => {
              return (
                <div>
                  {byIncident[x.properties["Incident #"]] && x && (
                    <CadDetail
                      cad={byIncident[x.properties["Incident #"]]}
                      derivedCad={x}
                    />
                  )}
                </div>
              );
            })}
        </div>
      )}
      <div className="map-container" ref={mapContainer}></div>
    </div>
  );
}

export default MapView;
